import React from 'react'
import IconButton from '@mui/material/IconButton'
import { ArrowLeft } from '@phosphor-icons/react'

export default function TowerUbiquaDetailHeader({
  title,
  subtitle,
  backLabel = 'Volver',
  onBack,
  children
}) {
  return (
    <header className="tower-ubiqua-detail-header">
      <IconButton
        className="tower-ubiqua-detail-header__back"
        onClick={onBack}
        aria-label={backLabel}
      >
        <ArrowLeft size={22} aria-hidden="true" />
      </IconButton>
      <div className="tower-ubiqua-detail-header__content">
        <h2>{title}</h2>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {children}
    </header>
  )
}
